const TERMINAL_REFRESH_CODES = new Set([
  "refresh_token_not_found",
  "refresh_token_already_used",
  "invalid_refresh_token",
  "invalid_grant",
]);
const CONFIRMED_SIGNED_OUT_CODES = new Set([
  ...TERMINAL_REFRESH_CODES,
  "session_not_found",
  "session_expired",
  "user_banned",
  "user_not_found",
]);
const CONFIRMED_SIGNED_OUT_NAMES = new Set([
  "authsessionmissingerror",
]);

function normalizedErrorCode(error) {
  return String(error?.error_code || error?.code || "")
    .trim()
    .toLowerCase();
}

function normalizedErrorMessage(error) {
  return String(
    error?.message ||
      error?.error_description ||
      error?.error ||
      error?.msg ||
      ""
  )
    .trim()
    .toLowerCase();
}

export function isRefreshTokenAlreadyUsedError(error) {
  if (!error) return false;
  if (normalizedErrorCode(error) === "refresh_token_already_used") return true;
  const message = normalizedErrorMessage(error);
  return (
    message.includes("refresh_token_already_used") ||
    message.includes("refresh token already used") ||
    message.includes("refresh token has already been used")
  );
}

export function isExpiredAccessTokenError(error) {
  if (!error || typeof error !== "object") return false;
  if (normalizedErrorCode(error) !== "bad_jwt") return false;

  const message = normalizedErrorMessage(error);
  return (
    message.includes("jwt expired") ||
    message.includes("token is expired") ||
    message.includes("token has expired") ||
    message.includes("expired token")
  );
}

export function isTerminalRefreshTokenError(error) {
  if (!error) return false;
  if (TERMINAL_REFRESH_CODES.has(normalizedErrorCode(error))) return true;
  const message = normalizedErrorMessage(error);
  return (
    message.includes("invalid refresh token") ||
    message.includes("refresh token not found") ||
    message.includes("refresh_token_already_used") ||
    message.includes("refresh token already used") ||
    message.includes("refresh token has already been used") ||
    message.includes("invalid_grant")
  );
}

export function isConfirmedSignedOutAuthError(error) {
  if (!error || typeof error !== "object") return false;
  if (error.confirmedInvalid === true) return true;

  const code = normalizedErrorCode(error);
  if (CONFIRMED_SIGNED_OUT_CODES.has(code)) return true;
  if (isTerminalRefreshTokenError(error)) return true;

  const name = String(error?.name || "").trim().toLowerCase();
  if (CONFIRMED_SIGNED_OUT_NAMES.has(name)) return true;

  const message = normalizedErrorMessage(error);
  return (
    message.includes("auth session missing") ||
    message.includes("auth session not found") ||
    message.includes("session not found")
  );
}
